import React from 'react'
import { K1View, K1Blindness } from '@e3dc-react/icons'
import { IconButton, IconButtonProps } from '@mui/material'

interface VisibilityIconProps extends IconButtonProps {
  isHidden: boolean
  isDisabled?: boolean
}

/**
 * Component that renders either a green eye or a striked through grey eye depending on the state
 */
const VisibilityIcon: React.FC<VisibilityIconProps> = ({ isHidden, isDisabled, ...props }) => {
  const Icon = isHidden ? K1Blindness : K1View

  return (
    <IconButton disabled={isDisabled} {...props}>
      <Icon
        sx={{
          color: 'primary.main',

          ...(isDisabled && {
            color: 'grey.grey03',
          }),
        }}
      />
    </IconButton>
  )
}

export default VisibilityIcon
